// constants
import { RevenueActionTypes } from "./constants";

export interface RevenueActionType {
  type: RevenueActionTypes.API_RESPONSE_SUCCESS | RevenueActionTypes.API_RESPONSE_ERROR | RevenueActionTypes.GET_REVENUE;

  payload: {} | string;
}

// common success
export const revenueApiResponseSuccess = (actionType: string, data: any | {}): RevenueActionType => ({
  type: RevenueActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const revenueApiResponseError = (actionType: string, error: string): RevenueActionType => ({
  type: RevenueActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getRevenue = (type: string, path: string, from?: any, to?: any): RevenueActionType => {
  return {
    type: RevenueActionTypes.GET_REVENUE,
    payload: {
      type,
      path,
      from,
      to,
    },
  };
};
